import type { VoidFunctionComponent } from 'react';

import { PolicyType } from '../../types';
import CallToAction from '../CallToAction';
import Flex from '../generic/Flex';
import PageHeadingBreadcrumbs from '../generic/PageHeadingBreadcrumbs';
import Text from '../generic/Text/Text';
import type { AsyncStatus, Policy } from '../../types';

import EditPolicyExportLicensingPolicyButton from './EditPolicyExportLicensingPolicyButton';

type DisplayPolicyNavProps = {
  policy?: Pick<Policy, 'id' | 'title' | 'description' | 'type'>;
  status?: AsyncStatus;
};

/**
 * Displays the top "Call to Action" header section for the edit policy page.
 */
const EditPolicyCTA: VoidFunctionComponent<DisplayPolicyNavProps> = ({ policy, status }) => {
  const title = (!policy || status?.isLoading) ? 'Loading...' : policy.title || 'Untitled';

  return (
    <CallToAction>
      <Flex justify="space-between" align="center">
        <PageHeadingBreadcrumbs
          crumbs={[
            {
              to: policy?.type
                ? `/policies/${policy.type.toLowerCase()}`
                : '/policies',
              text: 'Policies',
            },
            {
              text: title,
            },
          ]}
        />
        {policy?.type === PolicyType.LICENSING && (
          <EditPolicyExportLicensingPolicyButton policyId={policy.id} />
        )}
      </Flex>
      {policy?.description && (
        <Text>
          {policy.description}
        </Text>
      )}
    </CallToAction>
  );
};

export default EditPolicyCTA;
